import { type GTM } from '@vakantiesnl/types';

import { basicGTMV2Event } from './basicGTMV2Event';

type ErrorPageViewProps = {
	statusCode: number;
	errorMessage?: string;
	sub_page: GTM.GTMEventV2['sub_page'];
};

export const errorPageView = ({ statusCode, errorMessage, sub_page }: ErrorPageViewProps): GTM.GTMEventV2 =>
	basicGTMV2Event({
		type: 'view',
		organism: null,
		molecule: null,
		atom: null,
		action: 'page_view',
		label: null,
		page_type: 'errorPage',
		sub_page,
		entity_id: null,
		entity_level: null,
		value: {
			statusCode,
			errorMessage,
		},
	});
